export const articleQuery = {
    id: true,
    title: true,
    background_image: true,
    hover_preview_image: true,
    use_video_preview: true,
    video_url: true,
    tag: true,
    topics_reference: true,
    eventseries_reference: true,
    eventlocation_reference: true,
    subtitle: true,
    description: true,
    publication_date: true,
    person_reference: true,
    disable_primary: true,
    type: true,
    is_event: true,
    is_vlog: true,
    show_on_home: true,
    show_in_press: true,
    no_en_version: true,
    secondary_links: {
        query: "page.secondary_links.toStructure()",
        select: {
            text: true,
            link: true,
            target: true,
        },
    },
}
